import React, { createContext, useState, useContext, useEffect } from 'react';

export const LocaleContext = createContext();

export const LocaleProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('locale') || 'en';
  });
  const [noLocale, setNoLocale] = useState(false);
  const weglotOptions = {
    translate_els: '#root',
    originalLanguage: 'en',
    destinationLanguages: 'es,vi,ar',
    hide_switcher: noLocale,
    wait_transition: true,
    cache: true,
  };

  useEffect(() => {
    let isWeglotInitialized = false;

    try {
      if (window.Weglot) {
        // console.log('Weglot library loaded');
        Weglot.initialize({
          api_key: 'wg_8cd218082ca06d8b93409ecb11024c581',
          ...weglotOptions,
        });

        isWeglotInitialized = true;

        try {
          window.Weglot.on('languageChanged', (newLang) => {
            setLocale(newLang);
            // console.log('Locale changed to:', newLang);
          });
        } catch (error) {
          console.error('Error setting up Weglot language change listener:', error);
        }
      } else {
        if (!process.env.STORYBOOK) {
          console.error('Weglot library not loaded');
        }
      }
    } catch (error) {
      console.error('Error initializing Weglot:', error);
    }

    return () => {
      // Safe cleanup - don't try to use methods that don't exist
      try {
        if (window.Weglot && isWeglotInitialized) {
          // Most event libraries support removing listeners, but check first
          if (typeof window.Weglot.off === 'function') {
            window.Weglot.off('languageChanged');
          }
        }
      } catch (error) {
        console.error('Error during Weglot cleanup:', error);
      }
    };
  }, [noLocale, weglotOptions.hide_switcher]);

  useEffect(() => {
    // Update localStorage whenever locale changes
    localStorage.setItem('locale', locale);
  }, [locale]);

  const changeLocale = (newLocale) => {
    try {
      // console.log('Switching language to:', newLocale);
      setLocale(newLocale);
      if (window.Weglot && typeof window.Weglot.switchTo === 'function') {
        window.Weglot.switchTo(newLocale);
      }
    } catch (error) {
      console.error('Error changing locale:', error);
    }
  };

  return <LocaleContext.Provider value={{ lang: locale, locale, changeLocale }}>{children}</LocaleContext.Provider>;
};

export const useLocale = () => {
  return useContext(LocaleContext);
};
